import { graphql } from "../gql";

export const songsIdsQuery = graphql(`
  query songsIdsQuery {
    songs {
      id
    }
  }
`);

export const songsDeltaQuery = graphql(`
  query songsDeltaQuery($updatedSince: OffsetDateTime) {
    songs(updatedSince: $updatedSince) {
      ...SongFields
    }
  }
`);

export const songsFullQuery = graphql(`
  query songsFullQuery {
    songs {
      ...SongFields
    }
  }
`);
